import styles from "./styles.module.css";
import { createRow } from "../../../utils/databaseactions";
import { useParams } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { DatabaseValue } from "../../../contexts/database";
import { TypesValue } from "../../../contexts/types";
import { UserValue } from "../../../contexts/user";
import { MdClose } from "react-icons/md";
import Modal from "../../../modal";
import { storage } from "../../../firebase";

export default function DataModal({ updateData, setOpen, open, tableId, fields }) {
  const [fnIsRunning, setFnIsRunning] = useState(false);
  const [fieldIds, setFieldIds] = useState(null);
  const [data, setData] = useState(null);
  const context = useContext(DatabaseValue);
  const types = useContext(TypesValue);
  const user = useContext(UserValue);
  const [files, setFiles] = useState({});
  const { appId } = useParams();

  const add = async () => {
    let newData = Object.assign({}, data);
    Object.keys(newData).forEach(key => {
      if (newData[key] === "") delete newData[key];
    });
    let fileMap = null;
    if (JSON.stringify(files) !== "{}") {
      fileMap = await uploadFiles(files);
    }
    Object.keys(newData).forEach(key => {
      const f = fields[key];
      if (!!f.list) {
        newData[key] = newData[key].split(",");
      }
      else if (f.type === "Image" || f.type === "File") {
        let filename = newData[key].name;
        newData[key] = JSON.stringify(fileMap[filename]);
      }
      else if (f.type === "Date") {
        newData[key] = new Date(newData[key]).toISOString();
      }
      else if (f.type === "Location") {
        newData[key] = JSON.stringify(newData[key]);
      }
    });
    if (Object.keys(newData).length === 0) {
      console.log("can't add an empty row to the database");
      return;
    }
    setFnIsRunning(true);
    const d = createRow(appId, tableId, newData, user);
    d.then(() => {
      updateData();
    })
    .catch(err => {
      `console`.log(err);
    })
    .finally(() => setOpen(false));
  }

  const uploadFiles = async (_files) => {
    const fileMap = {};
    for (let key in _files) {
      const _f = _files[key];
      const storageRef = storage.ref(`${appId}/files/${_f.name}`);
      const data = await storageRef
        .put(_f)
        .then(async snap => {
          const url = await snap.ref.getDownloadURL();
          const ref = snap.ref;
          const obj = {
            name: ref.name,
            fullPath: ref.fullPath,
            bucket: ref.bucket,
            src: url,
            metadata: snap.metadata
          }
          return obj;
        });
      fileMap[key] = data;
    }
    return fileMap;
  }

  const handleFileUpload = (target, field) => {
    let newData = Object.assign({}, data);
    const file = target.files[0];
    const fileInfo = {
      name: file.name,
      type: file.type,
      ext:  file.name.split(".").pop(),
      lastModified: file.lastModified,
      size: file.size
    };
    newData[field] = fileInfo;
    setFiles({...files, [fileInfo.name]: file});
    setData(newData);
  }

  const handleFileRemove = (fileName, field) => {
    const newFiles = Object.assign({}, files);
    delete newFiles[fileName];
    const newData = Object.assign({}, data);
    newData[field] = null;
    setFiles(newFiles);
    setData(newData);
  }
  
  const handleChange = (val, field) => {
    let newData = Object.assign({}, data);
    newData[field] = val;
    setData(newData);
  }
  
  const handleJSONChange = (val, field, key) => {
    let newData = Object.assign({}, data);
    let obj = typeof newData[field] === "object" ? { ...newData[field] } : {};
    obj[key] = val;
    newData[field] = { ...obj} ;
    setData(newData);
  }
  
  const formatForSubmit = (type, value) => {
    try {
      switch (type) {
        case "Text":
          return !!value ? value : "";
        case "True/False":
          return !!value ? value : false;
        case "Date":
          return !!value ? new Date(value).toISOString() : null;
        case "Location":
          return !!value ? JSON.stringify(value) : null;
        default:
          return !!value ? value : "";
      }
    }
    catch (err) {
      return value;
    }
  }

  const formatForInput = (type, value) => {
    try {
      switch (type) {
        case "True/False":
          return value;
        case "Date":
          return !!value ? value.split("T")[0] : "";
        case "Location":
          return !!value ? value : "";
        default:
          return value
      }
    }
    catch (err) {
      return value;
    }
  }

  useEffect(() => {
    if (!!fields) {
      setFieldIds(Object.keys(fields));
    }
  }, [fields, open]);

  useEffect(() => {
    if (!!fieldIds && !data) {
      let newData = {};
      fieldIds.forEach(key => {
        if (!fields[key].editable) return;
        if (fields[key].type === "True/False") newData[key] = false;
        else newData[key] = "";
      });
      setData(newData);
    }
  }, [fieldIds, data, fields]);

  useEffect(() => {
    if (!open) {
      setData(null);
      setFieldIds(null);
      setFnIsRunning(false);
    }
  }, [open, tableId]);

  const mapType = (type) => {
    for (let i = 0; i < types.length; i++) {
      if (types[i].name === type) return types[i];
    }
    return null;
  }

  const createInput = (f, fid) => {
    const type = mapType(f.type);
    const value = formatForInput(type.name, data[fid]);
    if (!type || type.name === "Text") {
      return <input 
              name={f.name}
              type="text" 
              value={value}
              onChange={(e) => handleChange(e.target.value, fid)}
              className="input" />;
    }
    if (type.name === "Location") {
      return (
        <div className={styles.split}>
          <div>
            <label>Latitude</label>
            <input 
              name={f.name + "-lat"}
              type="text"
              value={value && value.lat}
              onChange={(e) => handleJSONChange(e.target.value, fid, "lat")}
              className="input"
            />
          </div>
          <div>
            <label>Longitude</label>
            <input 
              name={f.name + "-lng"}
              type="text"
              value={value && value.lng}
              onChange={(e) => handleJSONChange(e.target.value, fid, "lng")}
              className="input"
            />
          </div>
        </div>
      );
    }
    if (type.name === "Number") {
      return <input 
              name={f.name}
              type="number" 
              value={value}
              onChange={(e) => handleChange(e.target.value, fid)}
              className="input" />;
    }
    if (type.name === "Date") {
      return <input 
              name={f.name}
              type="date" 
              value={value}
              onChange={(e) => handleChange(e.target.value, fid)}
              className="input" />;
    }
    if (type.name === "Image" || type.name === "File") {
      if (value && value.name) {
        return (
          <>
            <input
              type="text"
              value={value.name}
              className="input"
              disabled
            />
            <input
              type="button"
              onClick={() => handleFileRemove(value.name, fid)}
              value="Remove file"
              className="input"
            />
          </>
        )
      }
      else {
        return (
          <>
          <input
              type="text"
              value=""
              className="input"
              disabled
            />
            <input 
              name={f.name}
              type="file"
              accept={type.name === "Image" ? 'image/*' : null}
              onChange={(e) => handleFileUpload(e.target, fid)}
              className="input"
            />
          </>
        )
      }
    }
    if (type.sqlType === "boolean") {
      return <input 
              name={f.name}
              type="checkbox" 
              checked={data[fid]}
              onChange={(e) => handleChange(e.target.checked, fid)}
              className="input" />;
    }
    if (type.sqlType === "jsonb") {
      return <textarea 
              name={f.name}
              value={value}
              onChange={(e) => handleChange(e.target.value, fid)}
              className="input" />
    }
    if (type.category === "database") {
      let tableName = "";
      for (let i = 0; i < context.length; i++) {
        if (context[i].id === type.name) {
          tableName = context[i].name;
          break;
        }
      }
      return <input 
              name={f.name}
              type="text" 
              value={value}
              placeholder={`Enter a ${tableName} id`}
              onChange={(e) => handleChange(e.target.value, fid)}
              className="input" />;
    }
  }

  const userForm = () => {
    const _fields = { ...fields };
    const _fieldIds = Object.keys(_fields);
    return _fieldIds.map(id => {
      if (["_id", "createdDate", "modifiedDate"].includes(id)) return null;
      return (
        <div key={id}>
          <div className={styles.formInputTitle}>{_fields[id].name}</div>
          {!!data ? createInput(_fields[id], id) : null}
        </div>
      )
    })
  }

  if (!open) return null;
  return (
    <Modal onClose={() => setOpen(false)} open={open}>
      <div className={styles.form}>
        <div className={styles.formTitle}>
          Add Data
          <MdClose onClick={() => setOpen(false)} className="icon" />
        </div>
        {fnIsRunning ? (
          <div className={styles.formContainer}>
            Adding data to database
          </div>
        ) : (
          <div className={styles.formContainer}>
            {tableId === "user" ? userForm() : ( 
            (fieldIds || []).map(id => {
              const n = fields[id].name;
              if (!fields[id].editable) return null;
              return (
                <div key={id}>
                  <div className={styles.formInputTitle}>{fields[id].name}</div>
                  {!!data ? createInput(fields[id], id) : null}
                </div>
              )
            }))}
          </div>
        )}
        <div className={styles.formContainer}>
          {fnIsRunning ? null : (
            <button disabled={false} onClick={add}>
              Submit
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}